import { apiDaInscricao } from "../../../servicos/axios";

export type Cidade = {
  id: number;
  cidade: string;
  dataAbertura: string;
  dataFechamento: string;
  descricaoDoPeriodo: string;
  status: "ABERTA" | "FECHADO" | "NENHUM";
};

export const buscarCidades = async (): Promise<Cidade[]> => {
  const response = await apiDaInscricao().get("/permissaoDasCidades");
  return response.data;
};
